import { h, JSX } from 'preact';

import { Box } from './Box';
import { CashModal, CashModalProps } from './CashModal';
import { ConfirmationModal, ConfirmationModalProps } from './ConfirmationModal';
import { DiscountsModal, DiscountsModalProps } from './DiscountsModal';
import { FiscalOpenSaleModal, FiscalOpenSaleModalProps } from './FiscalOpenSaleModal';
import { MessageModal, MessageModalProps } from './MessageModal';
import { OrderSummaryFooter, OrderSummaryFooterProps } from './OrderSummaryFooter';
import { OrderSummaryItem, OrderSummaryItemProps } from './OrderSummaryItem';
import { PartialPaymentModal, PartialPaymentModalProps } from './PartialPaymentModal';
import { Stack } from './Stack';
import { SummaryItemModal, SummaryItemModalProps } from './SummaryItemModal';
import { MembershipPurchaseModal, MembershipPurchaseModalProps } from './MembershipPurchaseModal';
import { MembershipRenewalModal, MembershipRenewalModalProps } from './MembershipRenewalModal';

export interface OrderSummaryProps {
    title: string;
    cashRegisterWarning?: string;
    tickets?: {
        title: string;
        items: OrderSummaryItemProps[];
    };
    products?: {
        title: string;
        items: OrderSummaryItemProps[];
    };
    discounts?: {
        title: string;
        items: OrderSummaryItemProps[];
    };
    footer: OrderSummaryFooterProps;
    viewButton?: {
        text: string;
        onClick?: () => void;
    };
    discountsButton?: {
        text: string;
        onClick?: () => void;
    };
    confirmationModal?: ConfirmationModalProps;
    partialPaymentModal?: PartialPaymentModalProps;
    summaryItemModal?: SummaryItemModalProps;
    cashModal?: CashModalProps;
    discountsModal?: DiscountsModalProps;
    membershipPurchaseModal?: MembershipPurchaseModalProps;
    membershipRenewalModal?: MembershipRenewalModalProps;
    fiscalOpenSaleModal?: FiscalOpenSaleModalProps;
    messageModal?: MessageModalProps;
}

export const OrderSummary = (props: OrderSummaryProps): JSX.Element => (
    <div class="lg:sticky lg:top-0 lg:min-h-screen flex flex-col justify-between p-6 lg:pb-0 bg-neutral-100 order-summary">
        <div>
            <div class="flex pb-3 gap-4">
                {props.discountsButton && (
                    <button
                        class="px-7 py-[17px] leading-[14px] grow btn btn-border"
                        onClick={props.discountsButton.onClick}
                    >
                        {props.discountsButton.text}
                    </button>
                )}
                {props.viewButton && (
                    <button
                        class="px-7 py-[17px] leading-[14px] grow btn btn-light-blue"
                        onClick={props.viewButton.onClick}
                    >
                        {props.viewButton.text}
                    </button>
                )}
            </div>
            <div class="border-b last:border-none py-6 first:pt-0 order-summary__section order-summary__section--first">
                <div class="font-semibold k-body-bold">{props.title}</div>
            </div>
            {props.cashRegisterWarning && (
                <div class="border-b last:border-none py-6 order-summary__section">
                    <div class="text-kinola-orange k-body-bold order-summary__warning">{props.cashRegisterWarning}</div>
                </div>
            )}
            {props.tickets && (
                <div class="border-b last:border-none py-6 order-summary__section">
                    <Box class="font-semibold pb-4 k-body-bold" paddingBottom={2}>
                        {props.tickets.title}
                    </Box>
                    <Stack direction="column" gap={1.25} class="flex flex-col">
                        {props.tickets.items.map((item) => (
                            <OrderSummaryItem {...item} />
                        ))}
                    </Stack>
                </div>
            )}
            {props.products && (
                <div class="border-b last:border-none py-6 order-summary__section">
                    <Box class="font-semibold pb-4 k-body-bold" paddingBottom={2}>
                        {props.products.title}
                    </Box>
                    <Stack direction="column" gap={1.25} class="flex flex-col">
                        {props.products.items.map((item) => (
                            <OrderSummaryItem {...item} />
                        ))}
                    </Stack>
                </div>
            )}
            {props.discounts && (
                <div class="border-b last:border-none py-6 order-summary__section">
                    <div class="font-semibold pb-4 k-body-bold">{props.discounts.title}</div>
                    <Box>
                        <Stack direction="column" gap={1.25} class="flex flex-col">
                            {props.discounts.items.map((item) => (
                                <OrderSummaryItem {...item} />
                            ))}
                        </Stack>
                    </Box>
                </div>
            )}
        </div>
        <OrderSummaryFooter {...props.footer} />
        {props.confirmationModal && <ConfirmationModal {...props.confirmationModal} />}
        {props.summaryItemModal && <SummaryItemModal {...props.summaryItemModal} />}
        {props.discountsModal && <DiscountsModal {...props.discountsModal} />}
        {props.cashModal && <CashModal {...props.cashModal} />}
        {props.partialPaymentModal && <PartialPaymentModal {...props.partialPaymentModal} />}
        {props.membershipPurchaseModal && <MembershipPurchaseModal {...props.membershipPurchaseModal} />}
        {props.membershipRenewalModal && <MembershipRenewalModal {...props.membershipRenewalModal} />}
        {props.fiscalOpenSaleModal && <FiscalOpenSaleModal {...props.fiscalOpenSaleModal} />}
        {props.messageModal && <MessageModal {...props.messageModal} />}
    </div>
);
